function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_2269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.1111C11.5342 11.1111 12.7778 9.86747 12.7778 8.33335C12.7778 6.79922 11.5342 5.55557 10 5.55557C8.4659 5.55557 7.22225 6.79922 7.22225 8.33335C7.22225 9.86747 8.4659 11.1111 10 11.1111ZM10 9.44446C10.6137 9.44446 11.1111 8.947 11.1111 8.33335C11.1111 7.7197 10.6137 7.22224 10 7.22224C9.38638 7.22224 8.88892 7.7197 8.88892 8.33335C8.88892 8.947 9.38638 9.44446 10 9.44446Z",
    fill: "#ADBFDF",
    style: {
      fill: "#ADBFDF",
      fill: "color(display-p3 0.6784 0.7490 0.8745)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6962 16.6667H5.2778C4.81757 16.6667 4.44447 17.0398 4.44447 17.5C4.44447 17.9603 4.81757 18.3333 5.2778 18.3333H14.7222C15.1825 18.3333 15.5556 17.9603 15.5556 17.5C15.5556 17.0398 15.1825 16.6667 14.7222 16.6667H11.3039C11.3289 16.6445 11.3545 16.6218 11.3804 16.5985C11.8966 16.1365 12.5859 15.4688 13.2772 14.645C14.6375 13.0242 16.1111 10.6746 16.1111 8.02968C16.1111 4.51155 13.5246 1.94446 10 1.94446C6.47549 1.94446 3.88892 4.51155 3.88892 8.02968C3.88892 10.6746 5.36255 13.0242 6.72281 14.645C7.41413 15.4688 8.1034 16.1365 8.61964 16.5985C8.64559 16.6218 8.67111 16.6445 8.6962 16.6667ZM10 3.61112C7.38807 3.61112 5.55558 5.4399 5.55558 8.02968C5.55558 10.0811 6.72084 12.05 7.99947 13.5736C8.62759 14.322 9.25776 14.933 9.73111 15.3566C9.82804 15.4433 9.91814 15.522 10 15.5922C10.0819 15.522 10.172 15.4433 10.2689 15.3566C10.7423 14.933 11.3725 14.322 12.0006 13.5736C13.2792 12.05 14.4445 10.0811 14.4445 8.02968C14.4445 5.4399 12.612 3.61112 10 3.61112Z",
    fill: "#ADBFDF",
    style: {
      fill: "#ADBFDF",
      fill: "color(display-p3 0.6784 0.7490 0.8745)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_2269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/iconLocation.2a56152bd97623075b286b7804e181b4.svg";
export { ForwardRef as ReactComponent };